import React from 'react';
import { CheckCircleOutlined, WarningOutlined, CloseOutlined } from '@ant-design/icons';
import {
  UploadResultBadgeStyled,
  UploadFailedCount,
  UploadDismissIcon,
} from './CompensationManagement.styles';

/**
 * Reusable pill badge showing bulk-upload results.
 *
 * @param {{ uploadResult: { successful: number, failed: number, total_rows: number }, onDismiss: () => void }} props
 */
const UploadResultBadge = ({ uploadResult, onDismiss }) => {
  if (!uploadResult) return null;

  const hasFailures = uploadResult.failed > 0;

  return (
    <UploadResultBadgeStyled $hasFailures={hasFailures}>
      {hasFailures ? <WarningOutlined /> : <CheckCircleOutlined />}
      {uploadResult.successful}/{uploadResult.total_rows} rows uploaded
      {hasFailures && (
        <UploadFailedCount> · {uploadResult.failed} failed</UploadFailedCount>
      )}
      <UploadDismissIcon onClick={onDismiss}>
        <CloseOutlined />
      </UploadDismissIcon>
    </UploadResultBadgeStyled>
  );
};

export default UploadResultBadge;
